module.exports = __webpack_public_path__ + "static/renewing-logo-98f8cfa2bd05ea6435ae35131ea237cc.png";